<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>账户管理</el-breadcrumb-item>
        <el-breadcrumb-item>账号管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px" inline>
        <el-form-item label="账号：">
          <el-input size="small" v-model="listParams.username" placeholder="请输入账号" />
        </el-form-item>
        <el-form-item label="名称：">
          <el-input size="small" v-model="listParams.title" placeholder="请输入名称" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleRefresh"> 查询 </el-button>
          <el-button size="small" @click="handleReset"> 重置 </el-button>
        </el-form-item>
      </el-form>
    </div>

    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" border>
        <el-table-column prop="username" align="center" label="账号" />

        <el-table-column prop="title" align="center" label="名称" />

        <el-table-column prop="mobile" align="center" label="手机号" />

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="handelEdit(scope.row)">编辑</el-button>
            <!-- <confirm-button
              type="text"
              style="margin: 0 10px;"
              title="确认要重置密码吗？"
              @confirmed="handelEdit(scope.row)"
            >
              <span class="color-warning">重置密码</span>
            </confirm-button> -->
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <!-- 信息更新弹窗 -->
    <InfoUpdate :dialogVisible.sync="dialogVisibleInfo" :dialogData="dialogData" @refresh="handleRefresh" />
  </div>
</template>

<script>
import InfoUpdate from "./dialog/InfoUpdate.vue";

export default {
  components: { InfoUpdate },

  data() {
    return {
      listParams: {
        pageIndex: 1,
        pageSize: 15,
        accountNum: "",
        username: "",
      },
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dialogVisibleInfo: false,
      dialogData: {},
    };
  },

  mounted() {
    this.handleRefresh();
  },

  methods: {
    /**
     * 刷新
     */
    handleRefresh() {
      this.listParams.pageIndex = 1;
      this.loadTableData();
    },
    /**
     * 重置
     */
    handleReset() {
      this.listParams = { accountNum: "", username: "" };
    },
    /**
     * 加载表格数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: `${global.apiUrl}/adminaccount/list`,
        method: "GET",
        params: { ...this.listParams },
      })
        .then(response => {
          const result = response.body || {};
          if (result.apiStatus === 0 && result.sysStatus === 0) {
            this.tableLoading = false;
            if (result.data) {
              this.tableData = result.data.data;
              this.pager.total = result.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
            this.$message({ message: result.info, type: "error" });
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },

    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.listParams.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.listParams.pageIndex = 1;
      this.listParams.pageSize = val;
      this.loadTableData();
    },
    /**
     * 编辑用户
     * @param {} data
     */
    handelEdit(data) {
      this.dialogData = data;
      this.dialogVisibleInfo = true;
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
